import React from 'react';
import { Col, Button, Row, ListGroupItem } from 'react-bootstrap';
import { FaCloud } from 'react-icons/fa';



/**UI component which handles the publish list element*/
export default class AdminTreeEntity extends React.Component {
    publishClick = () => {
        this.props.publishSite(this.props.id);
        // publishSite(this.props.id);
    };
    render() {
        return (
            <div key={this.props.id} >
                <ListGroupItem>
                    <Row>
                        <Col xs={6}>
                            {this.props.tableTitle} <b> Tree By: {this.props.companyName}</b> is ready for {this.props.state} publish
                        </Col>
                        <Col xs={6}>{this.props.publish ?
                            <div>
                                <Button onClick={() => this.props.viewState(this.props.id)}>View publish state</Button> &nbsp;
                                <Button onClick={this.publishClick}>
                                    Publish Site <FaCloud />
                                </Button>
                            </div>
                            : <p>Tree has been published</p>}
                        </Col>
                    </Row>
                </ListGroupItem>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/admin/adminTreeEntity.js